import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { AdminHeader } from "./AdminLayout";
import { Bell } from "lucide-react";

export default function AdminNotifications() {
  const [data, setData] = useState({ items: [], unread: 0 });
  useEffect(() => {
    api.get("/admin/notifications").then(r => setData(r.data));
    api.put("/admin/notifications/read").catch(() => {});
  }, []);
  return (
    <div>
      <AdminHeader title="Notifications" subtitle={`${data.items.length} recent events`} />
      <div className="space-y-2">
        {data.items.length === 0 && <p className="text-forest/50">No notifications.</p>}
        {data.items.map((n) => (
          <div key={n.id} className={`bg-white border border-sage/30 rounded-sm p-4 flex items-start gap-3 ${!n.read ? "border-l-2 border-l-forest" : ""}`}>
            <Bell size={16} className="text-moss mt-0.5" />
            <div className="flex-1"><div className="font-medium text-sm">{n.title}</div><div className="text-sm text-forest/60">{n.body}</div></div>
            <span className="text-xs text-forest/40">{new Date(n.at).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
